var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9347_733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6122 26.13C19.9881 27.2424 23.6465 25.0241 26.7712 21.1883C29.8959 17.3526 31.3169 13.3314 29.941 12.2383L26.4433 9.38702C25.061 8.28105 21.409 10.493 18.2778 14.3351C15.1467 18.1773 13.7322 22.192 15.1145 23.2852L18.6122 26.13Z",
    stroke: "white",
    strokeWidth: 1.18056,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4433 9.38715C27.8192 10.4995 26.4047 14.5015 23.2735 18.3372C20.1423 22.1729 16.4904 24.4232 15.1145 23.3109",
    stroke: "white",
    strokeWidth: 1.18056,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0275 17.6404L25.6653 14.8275",
    stroke: "white",
    strokeWidth: 1.18056,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2915 26.5457C13.0111 27.2287 11.6445 27.7382 10.2281 28.0608C6.08109 29.0325 2.39054 28.4252 1.97905 26.7055L1.09821 22.9784C0.686726 21.2587 3.72145 19.0787 7.86848 18.1006C9.59072 17.6725 11.375 17.547 13.1407 17.7298",
    stroke: "white",
    strokeWidth: 1.18056,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.09821 22.9783C1.50326 24.6916 5.1938 25.2989 9.34083 24.3272C10.3925 24.0832 11.4191 23.7429 12.4077 23.3107",
    stroke: "white",
    strokeWidth: 1.18056,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.29025 18.919L11.2568 23.7712",
    stroke: "white",
    strokeWidth: 1.18056,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8925 12.9544C15.2045 14.3928 11.3468 13.99 7.31553 12.0658C3.28424 10.1415 0.55169 7.41174 1.23965 5.97333L2.98847 2.35495C3.68286 0.916549 7.52128 1.31291 11.5719 3.23717C15.6224 5.16144 18.3357 7.8912 17.6413 9.32961L15.8925 12.9544Z",
    stroke: "white",
    strokeWidth: 1.18056,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98847 2.3548C2.30051 3.78681 5.01377 6.51658 9.06436 8.44084C13.1149 10.3651 16.9469 10.7679 17.6413 9.32945",
    stroke: "white",
    strokeWidth: 1.18056,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7964 4.43909L6.83328 7.20082",
    stroke: "white",
    strokeWidth: 1.18056,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9347_733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.6944,
    height: 28.3333,
    fill: "white",
    transform: "translate(0.416656 0.833313)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step-2.1f4ad74cd812479003a782fa2d71d106.svg";
export { ForwardRef as ReactComponent };